import closeButton from "./cross-button.svg"

const FeedbackModal = ({ message, toggleShow }: { message: string; toggleShow: () => void }) => {
    return (
        <div className="tngnt-fixed tngnt-inset-0 tngnt-bg-black tngnt-bg-opacity-50 tngnt-flex tngnt-justify-center tngnt-items-center tngnt-z-[5000]">
            <div className="tngnt-bg-white tngnt-relative tngnt-p-[15px] tngnt-rounded-lg tngnt-shadow-lg">
                <img src={closeButton} className="tngnt-w-[24px] tngnt-absolute tngnt-right-0 tngnt-top-[-28px] tngnt-cursor-pointer" onClick={toggleShow} />
                <p className="tangent_global_style">{message}</p>
            </div>
        </div>
    )
}

export default FeedbackModal